import { Skeleton } from '@mui/material';
import classNames from 'classnames';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'src/app/hooks';
import { DeviceVariables, fanVariables } from 'src/constants/deviceConstants';

import classes from './Fans.module.scss';
import Gauge from './Gauge/Gauge';

export interface FansProps {
  loading?: boolean;
  gaugeSize?: number;
  className?: string;
  disabled?: boolean;
}

const Fans: FC<FansProps> = ({
  loading = false,
  gaugeSize,
  className,
  disabled = false,
}) => {
  const { t } = useTranslation();

  const deviceDetails = useAppSelector((state) => state.device.deviceDetails);
  const variables = deviceDetails?.controller?.diagnostic?.variables;

  const fan1 = useMemo(
    () =>
      fanVariables?.find(
        (fan) => fan.parameterIdRcu === DeviceVariables.FAN_1_SPEED
      ),
    []
  );
  const fan2 = useMemo(
    () =>
      fanVariables?.find(
        (fan) => fan.parameterIdRcu === DeviceVariables.FAN_2_SPEED
      ),
    []
  );

  return (
    <div className={classNames(classes.Container, className)}>
      {!loading ? (
        <>
          <h5>{t('device:fans')}</h5>
          <section>
            <Gauge
              title={`${t('device:fan')}-1`}
              value={
                !disabled && variables?.[DeviceVariables.FAN_1_SPEED]?.value
              }
              minValue={fan1?.minValue}
              maxValue={fan1?.maxValue}
              size={gaugeSize}
            />
            <Gauge
              title={`${t('device:fan')}-2`}
              value={
                !disabled && variables?.[DeviceVariables.FAN_2_SPEED]?.value
              }
              minValue={fan2?.minValue}
              maxValue={fan2?.maxValue}
              size={gaugeSize}
            />
            <Gauge
              title={`${t('device:fan')}-3`}
              value={null}
              size={gaugeSize}
            />
          </section>
        </>
      ) : (
        <div className={classes.Loading}>
          <Skeleton animation="wave" variant="text" />
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={gaugeSize * 1.75 || 158}
          />
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={gaugeSize * 1.75 || 158}
          />
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={gaugeSize * 1.75 || 158}
          />
        </div>
      )}
    </div>
  );
};

export default Fans;
